(function () {
  if (window.wlyNotifyReady) return;
  window.wlyNotifyReady = true;
  function wlyMsg(box, text, kind) {
    var msg = box.querySelector('[data-wly-notify-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'wly-pb__notify-msg' + (kind ? ' is-' + kind : '');
    msg.hidden = !text;
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-wly-notify-open]') : null;
    if (!open) return;
    var box = open.closest('[data-wly-notify]');
    var form = box ? box.querySelector('[data-wly-notify-form]') : null;
    if (!form) return;
    var show = form.hidden;
    form.hidden = !show;
    open.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) {
      var input = form.querySelector('input[type="email"]');
      if (input) input.focus();
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-wly-notify-form]') : null;
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-wly-notify]');
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';
    if (!box || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      wlyMsg(box, box ? box.getAttribute('data-error') : '', 'error');
      return;
    }
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + box.getAttribute('data-variant') } }
        }
      }
    };
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    wlyMsg(box, '', '');
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(box.getAttribute('data-company')), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      var row = form.querySelector('.wly-pb__notify-row');
      if (row) row.hidden = true;
      wlyMsg(box, box.getAttribute('data-done'), 'done');
    }).catch(function () {
      wlyMsg(box, box.getAttribute('data-error'), 'error');
    }).then(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  });
})();
